export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const linkGroups = [
    {
      title: '内容板块',
      links: [
        { label: '话题热榜', href: '#topics' },
        { label: '最新动态', href: '#updates' },
        { label: '吃瓜专题', href: '#index' },
        { label: '热度排行', href: '#ranking' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <span className="text-2xl font-heading text-primary-500">网红黑料</span>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                抖音网红黑料、快手网红黑料每日更新平台。专注大号扒皮内幕、塌房翻车丑闻最新爆料，海量黑料实时更新，吃瓜第一站。
              </p>
            </div>

            {linkGroups.map((group) => (
              <div key={group.title}>
                <h3 className="text-sm font-semibold text-foreground-800 mb-4">{group.title}</h3>
                {group.links.length > 0 ? (
                  <ul className="space-y-2">
                    {group.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(e) => handleNavClick(e, link.href)}
                          className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-foreground-400">虚位以待</p>
                )}
              </div>
            ))}
          </div>

          <div className="border-t border-background-200/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 网红黑料。本站内容来源于网络公开信息，仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}